module.exports = __webpack_public_path__ + "static/media/visits.cf015e7e.svg";